import { render } from "./TechnicalData.vue?vue&type=template&id=6996b89b"
import script from "./TechnicalData.vue?vue&type=script&lang=js"
export * from "./TechnicalData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__